
import React, { useEffect, useState, } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector, } from "react-redux";
import { Link } from "react-router-dom";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Button from '@mui/material/Button';
// import Slider from "react-slick";
import AOS from "aos";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Calendar } from "primereact/calendar";
import dayjs from "dayjs";

import { all_routes } from "../../router/all_routes";
// import Footer from "../../common/footer";
import { RootState } from "../../../core/data/redux/store";
import { AppDispatch } from "../../../core/data/redux/store";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import {
  getFaq, addContactUs, resetContactUs, getProfile, getDealVehicles,
  //  getPopularCars,
  // fetchVehicles,
} from "../../../core/data/redux/action";
import {
  generateTimeOptions, getLocation,
  //  formatDateWithTime 
} from "../../../core/data/redux/actions/commonActions";
import ContactConfirm from "../../../core/data/modals/contactConfirm";
import ContactForm from "../../../core/data/modals/contact";
import moment from "moment";

//    import "../../../home.css";
//  import '../../../style/scss/pages/home-2.scss'
import Header from "../../common/header";
// import { FaStar, FaRegStar } from "react-icons/fa";

import {
  setSidebarFilters,
} from "../../../core/data/redux/actions/sidebarFilterActions";

import "aos/dist/aos.css";
import "swiper/css";

const HomeOne = () => {
  const [isMobile] = useState(window.innerWidth <= 767);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const today = new Date();
  const tomorrow = new Date();
  // tomorrow.setDate(tomorrow.getDate() + 1);
  // const [show, setShow] = useState(false);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(tomorrow);
  const [fromTime, setFromTime] = useState("");
  const [untilTime, setUntilTime] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [location, setLocation] = useState("1");

  // const [carsList, setCarsList] = useState([]);

  // const sidebarFilterState = useSelector((state: RootState) => state.sidebarFilter);
  // const selectedFilters = sidebarFilterState?.selectedFilters || {};
  // const memoizedFilters = useMemo(() => selectedFilters, [JSON.stringify(selectedFilters)]);
  // const [searchFilters,] = useState({});
  // const swiperRef = useRef(null);
  const routes = all_routes;

  //   useEffect(() => {
  //     const link = document.createElement('link');
  //     link.rel = 'stylesheet';
  //     link.href = require('../../../style/scss/pages/home-2.scss');
  //     link.setAttribute('data-dynamic-style', 'home-2');
  //     document.head.appendChild(link);

  //     return () => {
  //         const injectedLink = document.querySelector('link[data-dynamic-style="home-2"]');
  //         if (injectedLink) {
  //             document.head.removeChild(injectedLink);
  //         }
  //     };
  // }, []);


  // useEffect(() => {
  //   import('../../../style/scss/pages/home-2.scss');
  //   import('../../../home.css');

  //   return () => {
  //     // You can't truly "unload" imported CSS this way
  //     // Consider scoping styles with CSS modules instead
  //   };
  // }, []);

  // useEffect(() => {
  //     const link = document.createElement('link');
  //     link.rel = 'stylesheet';
  //     link.href = require('../../../style/scss/pages/home-2.scss');
  //     link.setAttribute('data-dynamic-style', 'home-2');
  //     document.head.appendChild(link);

  //     return () => {
  //         const injectedLink = document.querySelector('link[data-dynamic-style="home-2"]');
  //         if (injectedLink) {
  //             console.log(injectedLink, );

  //             document.head.removeChild(injectedLink);
  //         }
  //     };
  // }, []);

  // useEffect(() => {

  // dispatch(fetchVehicles(1, 10, "Newest",
  //   formatDateWithTime(startDate, fromTime),
  //   formatDateWithTime(endDate, untilTime),
  //   []
  // ));

  // const isRestrictedCustomer = localStorage.getItem("isRestrictedCustomer"); 

  // if (isRestrictedCustomer === ("true" || true)) {
  // navigate(`${all_routes.userDashboard}`);
  // } 
  //}, []);


  useEffect(() => {
    window.scrollTo(0, 0);

    if (localStorage.getItem("token")) {
      dispatch(getProfile());

    }

  }, [dispatch]);


  const { topDealCars, faqList, locationList,
    //  popularCars, selectedFilters,
    user, contactUsSuccess, contactUsError, contactUsLoading, systemSettings } = useSelector(
      (state: RootState) => ({

        // selectedFilters: state.sidebarFilterselectedFilters,
        contactUsSuccess: state.contactUs.contactUsSuccess,
        contactUsError: state.contactUs.contactUsError,
        contactUsLoading: state.contactUs.contactUsLoading,
        faqList: state.faq.faqList,
        topDealCars: state.vehicle.topDealCars,
        // popularCars: state.vehicle.popularCars,
        systemSettings: state.auth.systemSettings,
        user: state.auth.user,

        locationList: state.common.locationList,
      })
    );


  const [timeOptions, setTimeOptions] = useState<string[]>([]);

  // useEffect(() => {

  //   if (cars) {
  //     setCarsList(cars || []); // Use `||` instead of `??`
  //   }
  // }, [cars]);


  useEffect(() => {
    if (systemSettings.booking_start_time && systemSettings.booking_end_time) {
      const options = generateTimeOptions(systemSettings.booking_start_time, systemSettings.booking_end_time, 0);
      setTimeOptions(options);
    }
  }, [systemSettings.booking_start_time, systemSettings.booking_end_time]);


  type FormValues = {
    name: string;
    email: string;
    message: string;
    phone: string;
  };


  const schema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    message: Yup.string(),
    phone: Yup.string().when("$phone", {
      is: (value: any) => value?.trim().length > 0, // Check if phone is not empty
      then: (schema) => schema.length(10, "Phone must be exactly 10 digits"),
      otherwise: (schema) => schema.notRequired(), // Don't validate if empty
    }),
  });


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset: contactReset,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      name: user?.last_name ? user?.first_name + " " + user?.last_name : user?.first_name,
      email: user?.email,
      message: "",
      phone: user?.mobile,

    },
  });


  const onSubmit: SubmitHandler<FormValues> = (data) => {
    // const formattedNumber = "+12147762522";
    const currentUrl = `${window.location.origin}${location.pathname}${location.search}`;

    // const encodedMessage = encodeURIComponent(
    // `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, Enquiry :${data.message}`
    // );

    dispatch(addContactUs({
      ...data,
      vehicle_id: "",
      query_type: "enquiry",
      fairental_message: `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, Enquiry :${data.message}, please click on the link to see the car details: ${currentUrl}`

    }));

    // const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodedMessage}`;
    // window.open(whatsappUrl, "_blank");
  };


  const handleSearchSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault(); // Prevent form reload 
    const searchParams = new URLSearchParams({

      pickupDate: dayjs(startDate).format("YYYY-MM-DD"),
      pickupTime: fromTime,

      returnDate: dayjs(endDate).format("YYYY-MM-DD"),
      returnTime: untilTime,
    });


    navigate(`${all_routes.listingGrid}?${searchParams.toString()}`);

  };



  // useEffect(() => {
  // const finalFilters = { ...searchFilters, ...memoizedFilters };
  // dispatch(fetchVehicles(1, limit, sortBy, startDate?.toISOString().split('T')[0], endDate?.toISOString().split('T')[0], finalFilters));
  // }, [dispatch, limit, sortBy, memoizedFilters, searchFilters, cars.length]);




  useEffect(() => {

    dispatch(getLocation());

    dispatch(getFaq({ search: "" , is_top: true}));
    // dispatch(getPopularCars({ make: false }));
    dispatch(getDealVehicles());
    // dispatch(fetchVehicles(1, limit, sortBy, startDate?.toISOString().split('T')[0], endDate?.toISOString().split('T')[0], {}));
  }, []);


  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);


  // interface SlideData {
  // index: number;
  // imgSrc: string;
  // title: string;
  // description: string;
  // }

  // interface CarTypeSlideProps {
  // slide: SlideData;
  // }



  // const slideData: SlideData[] = [
  // // {
  // // index: 1,
  // // imgSrc: "assets/img/cars/choose_car.png",
  // // title: "Choose Your Car",
  // // description: "Browse our fleet and select the perfect ride for your needs.",
  // // },
  // {
  // index: 1,
  // imgSrc: "assets/img/cars/book_car.png",
  // title: "Book Exclusively",
  // description: "Reserve your car for your chosen term. No sharing—it’s all yours until drop-off.",
  // },
  // {
  // index: 2,
  // imgSrc: "assets/img/cars/pay.png",
  // title: "Pay Daily",
  // description: "Enjoy the convenience of daily payments while enjoying the benefits of a long-term rental.",
  // },
  // {
  // index: 3,
  // imgSrc: "assets/img/cars/drive_away.png",
  // title: "Drive Away",
  // description: "With insurance, maintenance, and unlimited mileage included, you’re set for the road ahead.",
  // },
  // {
  // index: 4,
  // imgSrc: "assets/img/cars/support.png",
  // title: "Support When You Need It",
  // description: "Got a question? Our friendly team is available via text 24/7 and by phone for 12 hours a day.",
  // },
  // ];


  // const CarTypeSlide: React.FC<CarTypeSlideProps> = ({ slide }) => (
  // <div className="position-relative">

  // <div className="listing-owl-item">
  // <div className="listing-owl-group p-0 px-md-4">
  // <div className="listing-owl-img">
  // <ImageWithBasePath src={slide.imgSrc} className="img-fluid" alt={slide.title} />
  // </div>

  // {/* <div className="row">
  // <div className="col-2">
  // <h1 className="mb-0 text-primary">{slide.index ?? ''}</h1>
  // </div>
  // <div className="col-10">
  // <div className="listing-owl-content">
  // <p className="mb-0">{slide.description}</p>
  // </div>
  // </div>
  // </div> */}
  // </div>
  // </div>
  // </div>
  // );



  const closeModal = () => {
    const modalElement = document.getElementById("enquiry");
    const confirmModal = document.getElementById("confirm");

    if (confirmModal) {
      confirmModal.classList.add("show", "modal-open");
      confirmModal.style.display = "block";
    }

    if (modalElement) {
      modalElement.style.display = "none";
    }

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

  };

  const closeConfirmModal = () => {
    const backdrop = document.querySelector(".modal-backdrop");
    const confirmModal = document.getElementById("confirm");

    if (confirmModal) {
      confirmModal.style.display = "none";
      confirmModal.classList.remove("show", "modal-open");
    }
    if (backdrop) {
      backdrop.remove();
    }
  }


  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');


  useEffect(() => {
    if (contactUsSuccess) {
      showToast(contactUsSuccess);
      //reset();
      closeModal();
      dispatch(resetContactUs());
      // navigate(routes.bookingAddon);
    } else if (contactUsError) {
      showToast(contactUsError);
      // reset();
      dispatch(resetContactUs());
    }

  }, [contactUsSuccess, contactUsError]);

  const showToast = (message: any) => {
    setToastClass((contactUsError) ? 'bg-danger text-white' : 'bg-success text-white')

    setToastMessage(message);
  };


  const handleCloseToast = () => {
    setToastMessage('');
  };


  useEffect(() => {

    if (systemSettings && systemSettings?.booking_min_duration) {


      tomorrow.setDate(tomorrow.getDate() + parseInt(systemSettings?.booking_min_duration));

      setStartDate(today);
      setEndDate(tomorrow);

      setFromTime(moment(systemSettings?.booking_start_time, 'HH:mm').format('h:mm A'));
      setUntilTime(moment(systemSettings?.booking_end_time, 'HH:mm').format('h:mm A'));

    }

  }, [systemSettings, systemSettings?.booking_min_duration]);


  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      } else {
        toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      }

    }
  }, [toastMessage, toastClass]);


  useEffect(() => {

    if (user) {


      contactReset({
        name: user.name ?? "",
        email: user.email ?? "",
        phone: user.mobile ?? "",
        message: "",
      });
    }
  }, [user, contactReset, contactUsSuccess]);



  const popularCars = [
    { name: "Sedan", imageUrl: '/assets/img/home/Sedan.png', price: "69" },
    { name: "Compact SUV", imageUrl: '/assets/img/home/SUV.png', price: "79" },
    { name: "Full SUV", imageUrl: '/assets/img/home/Full SUV.png', price: "89" },

  ];

  const BrowseByCategory = () => (
    <div className="services-work text-center align-items-end row">

      <h2  >Browse by Category</h2>

      {popularCars.map((category, index) => (

        <div key={index} className="services-group p-1 pe-2 col-12 col-md-4" style={{
          cursor: "pointer",
        }} onClick={() => {


          dispatch(setSidebarFilters({ body_style: category.name }));



          handleSearchSubmit();

        }}>
          <img
            style={{
              width: index === 2 ? "17rem" : "20rem",
              marginBottom: index === 0 ? "-3rem" : index === 2 ? "-2.2rem" : "-1.8rem",
              marginTop: index === 0 ? "-3rem" : index === 2 ? "0.6rem" : ""


            }}
            src={category.imageUrl}
            alt={`${category.name} image`}
          />
          <div className="category-card">
            <h3  >{category.name}</h3>
            <p className=" " style={{ marginTop: "6px" }}>{`From $${category.price}/day`}</p>
          </div>
        </div>

      ))}
    </div>
  );

  const categories = [
    {
      title: "Search",
      descriptions: "Browse our diverse vehicle selection by dates or specific features.",
    },
    {
      title: "Book",
      descriptions: "Reserve the car. Select your dates & confirm your booking instantly.",

    },
    {
      title: "Enjoy",
      descriptions: "Pick your car - Pay as you earn, unlimited miles, zero hassle.",

    },
  ];

  const HowItWorks = () => (
    <div className="services-work" >
      <div className="bg-services-work" >
        <div>
          <h2 className="mb-5 text-white">How<br />
            it works</h2>
          <div className="row">

            {categories?.map((category: any, index: number) => (
              <div className="col-8 col-md-4" data-aos="fade-down" key={index}>
                <div className="services-group p-0">

                  <div className="services-content">
                    <h3 className="d-flex gap-3 align-items-center text-white"  >
                      <span style={{
                        border: "1px solid rgb(170, 238, 238)",
                        borderRadius: "35px",
                        width: "3.5rem",
                        padding: "8px",
                        textAlign: "center"

                      }}> {index + 1}</span> {category.title}</h3>
                    <p className="text-justify text-white  "  >{category.descriptions}.</p>
                  </div>
                </div>
              </div>
            ))}

            <div className="col-12 text-end how-footer" >
              <img src={`${isMobile ? '../../assets/img/home/carvan-car-img.png' : '../../assets/img/home/carvan-car-desktop.png'}`} style={{ width: "20%" }} />
            </div>

          </div>
        </div>
      </div>
    </div >
  );


  const StarRating = ({ rating }: { rating: number }) => {
    const percentage = (rating / 5) * 100;

    return (
      <span className="ms-1" style={{ position: "relative", display: "inline-block", fontSize: "28px" }}>
        {/* Gray background stars */}
        <div style={{ color: "#D6DFE6" }}>
          {"★★★★★"}
        </div>

        {/* Orange fill overlay */}
        <div
          style={{
            color: "#DC5821",
            position: "absolute",
            top: 0,
            left: 0,
            width: `${percentage}%`,
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {"★★★★★"}
        </div>
      </span>
    );
  };


  const FairentalSection = () => {
    return (
      <div className="services-work"  >

        <div className="d-block d-md-flex gap-md-4 py-1">
          <div className="w-100 mb-1">
            <h2 className="  mb-2 text-white   mb-0"  >Fairental   </h2>
            <span className="  mb-2 text-white   mb-0" > Your trusted partner </span>
          </div>

          <div className="w-100 mb-2 py-1 d-flex justify-content-center">
            <img
              src={isMobile ? "assets/img/home/partner.png" : "assets/img/home/partner-desktop.png"}
              alt="Fairental"
              style={{ width: "100%", height: "129pt", objectFit: isMobile ? "contain" : "fill" }}
            />
          </div>

        </div>


        <p className="mb-4  text-justify text-territory"  >
          {` At Fairental, we believe in creating hassle-free rental experiences built on trust, transparency, and customer satisfaction. Whether you're renting a vehicle for a short trip or managing a growing fleet, our platform offers reliable solutions tailored to your unique needs. Our user-friendly interface, responsive support, and clear pricing ensure a smooth, stress-free rental process every time.`}
        </p>
        <p className="mb-2 text-justify text-territory">
          {`With Fairental, you're not just choosing a service—you're choosing a long-term partner committed to your success. Choosing Fairental means choosing a partner who values your time, effort, and goals. We understand the challenges drivers face and work hard to provide dependable service, timely assistance, and fair pricing. Whether you're delivering, commuting, or working with ride-share platforms, Fairental is here to help you earn more with ease. Join our growing network of trusted drivers and experience the difference of driving with a partner who truly has your back.`}   </p>


        <div className="services-group d-grid d-md-flex gap-3  gap-md-5 pt-md-5   ">
          <div className=" w-100 blue-border">
            <h2 className="text-primary fw-bold">
              2K<span className="text_gold">+</span>
            </h2>
            <p className="text-white">Total trips completed</p>
          </div>

          <div className="  w-100 blue-border">
            <h2 className="text-primary fw-bold  " style={{
              lineHeight: "96px"
            }}> 4.9/5

              <StarRating rating={4.70} />

            </h2>
            <p className="text-white">Customer ratings based on real reviews</p>
          </div>

          <div className="w-100  blue-border">
            <h2 className="text-primary fw-bold ">
              120<span className="text_gold">+</span>
            </h2>
            <p className="text-white">Trusted vehicles in our fleet </p>
          </div>
        </div>
      </div>

    );
  };


  const DriverIncomeSection = () => {
    const title = "Drivers are taking home $3000-$5000 a month";
    const para1 = "Looking to earn with zero hassle? With Fairental, drivers can rent a car and start earning immediately through Uber or Fairental’s own platform. Enjoy the freedom of unlimited miles and the flexibility to pay rent as you earn—no big upfront costs, no worries.";
    const para2 = " And with a clean driving record, you’re all set to take the car from your work to your home. Simple, smooth, and stress-free—Fairental makes driving for income easier than ever.";

    return (

      <div className="services-work">
        <div className="d-md-none">
          <div className="d-block d-md-flex">
            <h2 className="  fw-normal w-100" >{title}</h2>


            <div className="mb-2 w-100 d-flex justify-content-center">
              <img src={"assets/img/home/Mask Group 2.png"}
                alt="Fairental Uber"
                className="rounded-circle img-fluid"
                style={{ width: "100%", height: "129pt", objectFit: "contain" }}
              />
            </div>

          </div>

          <p className="mb-3 text-secondary-dark" >{para1}   </p>
          <p className="text-secondary-dark">{para2}  </p>
        </div>

        <div className="d-none d-md-flex">
          <div className="row ">
            <div className="col-12 col-md-5">
              <h2 className=" fw-normal  " >{title}</h2>

              <p className="mb-3 text-secondary-dark pt-md-3" >{para1}   </p>
              <p className="text-secondary-dark pb-md-3">{para2}  </p>

              <button className="btn     text-white w-50"
                onClick={() => { handleSearchSubmit(); }}
                style={{
                  background: "linear-gradient(99deg, #00B6F0, #9AE6FD )",
                  padding: "8px 0px",

                }} > Search for Cars </button>
            </div>

            <div className="col-12 col-md-7 mb-2   d-flex justify-content-center">
              <img
                src={isMobile ? "assets/img/home/Mask Group 2.png" : "assets/img/home/Group 29.png"}
                alt="Fairental Uber"

              />
            </div>

          </div>


        </div>

      </div>


    );
  };



  type TestimonialData = {
    text: string;
    name: string;
    location: string;
  };

  const testimonials: TestimonialData[] = [
    {
      text: "Clean car, constant contact with the host. Awesome service I highly recommend would definitely book again!",
      name: "Carlos May 9, 2025",
      location: "Buick Encore 2019"
    },
    {
      text: "Another great trip in the 2025 Toyota rav4. Love the host of this suv. Another 5 star trip done. I will definitely rent again same vehicle if available. Host answers promptly to my questions or concerns. I love it here and you will too. See u friday for another great trip.",
      name: "Tracy May 15, 2025",
      location: "Toyota RAV4 2025"
    },
    {
      text: "Car very clean. One of my favorites from this host. Host super professional. This is my number one host whenever I rent common. 5 stars across the board",
      name: "NaTasha May 30, 2025",
      location: "Nissan Kicks 2025"
    }
  ];

  const Testimonial: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
      }, 5000);

      return () => clearInterval(interval);
    }, []);

    const handleDotClick = (index: number) => {
      setCurrentIndex(index);
    };

    return (
      <div className="services-work">
        <h2 style={styles.heading} className="text-white ">Why they  Choose Fairental</h2>
        <div className="services-group py-2 py-md-5">

          <div style={styles.quoteIcon}><ImageWithBasePath
            className="icon-img "
            src="assets/img/home/quotes.svg"
            alt="Choose Locations"
          /> </div>
          <p style={styles.text} className="text-white">{testimonials[currentIndex].text}</p>
          <p style={styles.author} className="text-white" >
            {testimonials[currentIndex].name} &nbsp;|&nbsp; {testimonials[currentIndex].location}
          </p>

          <div className="d-flex align-items-center justify-content-between">

            <div style={styles.dots}>
              {testimonials.map((_, index) => (
                <span
                  key={index}
                  onClick={() => handleDotClick(index)}
                  style={{
                    ...styles.dot,
                    backgroundColor: currentIndex === index ? '#fff' : '#004466',
                    width: currentIndex === index ? '30px' : '15px',
                    height: currentIndex === index ? '30px' : '15px'
                  }}
                />
              ))}
            </div>


            <button className="btn bg-white border">
              <Link to="https://g.page/r/CVqntnlVHvsjEAI/review" className="text-black " target="_blank" > More </Link>


            </button>

          </div>
        </div>



      </div>
    );
  };


  const TopDealCars: React.FC = () => {
    return (
      <div className="services-work">

        <h2 className="text-center ">Popular Cars Nearby</h2>

        <div className="row">

          {topDealCars?.map((car: any, index: any) => (
            <div
              key={car?.vin}

              className="col-md-4 col-12"
            >
              <div className="listing-item"  >
                <div className="listing-img m-0" onClick={() => {
                  navigate(`${routes.listingDetails}/${car?.vin}?pickupDate=${dayjs(startDate).format("YYYY-MM-DD")}&pickupTime=${fromTime}&returnDate=${dayjs(endDate).format("YYYY-MM-DD")}&returnTime=${untilTime}`)
                }}>
                  <div className="img-slider listing-page-slider">
                    {car?.vehicle_image ? (

                      <div className="fit-image-grid-container"  >

                        <ImageWithBasePath src={car?.vehicle_image} alt={`Vehicle Image ${index + 1}`} />
                      </div>

                    ) : (
                      <div className="no-slider-image">

                        <ImageWithBasePath
                          src="assets/img/cars/no_image.svg"
                          className="img-fluid car-image"
                          alt="Vehicle Image"
                        />

                      </div>
                    )}
                  </div>
                  <div className="fav-item justify-content-end">
                    <span className="img-count">
                      <i className="feather icon-image" />
                      {car?.images?.length}
                    </span>

                  </div>
                  <span className="featured-text" style={{
                    bottom: "unset",
                    top: "10px"
                  }}>{car?.car_category}</span>



                </div>
                <div className="listing-content mt-0" >
                  <div className="listing-features p-0 m-0 border-0 mb-3 d-flex align-items-end justify-content-between" onClick={() => {
                    navigate(`${routes.listingDetails}/${car?.vin}?pickupDate=${dayjs(startDate).format("YYYY-MM-DD")}&pickupTime=${fromTime}&returnDate=${dayjs(endDate).format("YYYY-MM-DD")}&returnTime=${untilTime}`)
                  }}>
                    <div className="list-rating">

                      <h3 className="listing-title">
                        <Link
                          to={`${routes.listingDetails}/${car.vin}`}
                        >
                          {car?.vehicle_name}
                        </Link>
                      </h3>

                      <div className="listing-price">



                        {/* <ImageWithBasePath
                          src="assets/img/home/map.png"
                          alt="map"
                        /> */}

                        < i className="feather icon-map-pin" />




                        <span className="text-secondary-dark" > Dallas, Texas </span>
                      </div>

                    </div>

                    <div className="listing-location-details justify-content-end px-2" >

                      <div className="listing-price">
                        <h6>
                          ${Math.round(Number(car?.price_per_day ?? 0))}{" "}
                          <span className="me-0">/ Day</span>
                        </h6>
                      </div>
                    </div>
                  </div>


                  <div className="listing-details-group mb-2" style={{
                    borderTop: "1px solid #B3D5E0",
                    padding: 10
                  }}>

                    <ul>


                      <li className="place-content-center" style={{
                        placeContent: "center",
                      }}>
                        <span>
                          <ImageWithBasePath
                            src="assets/img/home/seat.svg"
                            alt="Persons"
                          />
                        </span>
                        <p>{car?.seating_capacity ?? 0} Persons</p>
                      </li>
                      <li style={{
                        placeContent: "center",
                      }}>
                        <span>
                          <ImageWithBasePath
                            src="assets/img/home/wheel_steering.svg"
                            alt={car?.series}
                          />
                        </span>
                        <p>{"CarPlay"}</p>
                      </li>

                      <li style={{
                        placeContent: "center",
                      }}>
                        <span>
                          <ImageWithBasePath
                            src="assets/img/home/calendar.svg"
                            alt={car?.total_bookings}
                          />
                        </span>
                        <p>{car?.total_bookings} {car?.total_bookings === "1" ? "Trip" : "Trips"} </p>
                      </li>

                    </ul>
                  </div>


                </div>

              </div>
            </div>
          ))
          }
        </div>





        <div className="row justify-content-center mb-2">

          <div className="col-12 col-md-4  ">
            <div className="px-2 text-center">

              <button onClick={() => { handleSearchSubmit(); }}
                className="btn bg-none border border-primary  text-primary w-100  ptb1516 " type="button" >View More Cars </button>

            </div>

          </div>
        </div>

      </div>
    )


  };


  // Simple inline styles
  const styles: { [key: string]: React.CSSProperties } = {

    heading: {

    },
    quoteIcon: {
      paddingTop: '20px',
    },
    text: {
      fontSize: isMobile ? '20px' : '30px',
      // lineHeight: isMobile ? '36px' : '57px',
      marginTop: '-4rem',
    },
    author: {
      fontSize: '20px',
      // opacity: 0.8,
      lineHeight: '23px',
      marginTop: "18px",
      marginBottom: "36px"
    },
    dots: {
      alignItems: "center",
      display: 'flex',
      justifyContent: 'start',
      gap: '8px'
    },
    dot: {

      borderRadius: '50%',
      cursor: 'pointer',
      transition: 'background-color 0.3s'
    }
  };



  const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index: any) => {
      setOpenIndex(openIndex === index ? null : index);
    };

    return (
      <>

        <div className="row"  >
          <div className="col-6 d-md-grid d-none justify-content-end"  >

            <div className="mb-2 w-100  ">
              <img
                src={"assets/img/home/faq.png"}


                alt="Fairental Uber"
                className="rounded-circle img-fluid"
                style={{ width: "100%", height: "478pt", objectFit: "contain" }}
              />
            </div>

          </div>

          <div className="col-12 col-md-6">

            <h2 style={faqStyles.heading}  >FAQs </h2>


            {faqList?.slice(0, 5)?.map((faq: any, index: any) => (
              <div key={index} style={faqStyles.faqItem}>
                <div
                  onClick={() => toggleFAQ(index)}
                  style={faqStyles.questionRow}
                >
                  <p style={faqStyles.question}>{faq.question}</p>
                  <span style={faqStyles.arrow}>
                    {openIndex === index ? <ImageWithBasePath
                      className="icon-img"
                      src="assets/img/home/arrow down.svg"
                      alt="Choose Locations"
                    /> : <ImageWithBasePath
                      className="icon-img "
                      src="assets/img/home/arrow down.svg"
                      alt="Choose Locations"
                    />}
                  </span>
                </div>

                {openIndex === index && (
                  <div style={faqStyles.answer}>

                    <div className="fqList" dangerouslySetInnerHTML={{ __html: faq.answer }} /> </div>
                )}

                <div style={faqStyles.divider}></div>
              </div>
            ))}


            {faqList?.filter((item: any) => item.is_top === true)?.length > 5 &&
              <div className="row justify-content-center mb-2">

                <div className="col-12 col-md-4  ">
                  <div className="px-2 text-center">

                    <button onClick={() => {
                      navigate(routes.faq);
                    }}
                      className="btn bg-none border border-primary  text-primary w-100  ptb1516 " type="button" >View More </button>

                  </div>

                </div>


              </div>
            }

          </div>

        </div>
      </>

    );
  };

  const faqStyles = {

    heading: {
      fontSize: '36px',
      lineHeight: '50px',
      marginBottom: '30px'
    },

    faqItem: {
      marginTop: '20px',
      marginBottom: '20px'
    },
    questionRow: {
      display: 'flex',

      justifyContent: 'space-between',
      cursor: 'pointer',
      padding: '10px 0'
    },
    question: {
      fontSize: '18px',
      lineHeight: '28px',
      margin: 0,
      color: '#23233C'
    },
    arrow: {
      fontSize: '16px'
    },
    answer: {
      fontSize: '14px',
      color: '#777',
      marginTop: '5px',
      padding: '5px 0'
    },
    divider: {
      borderTop: '1px solid #ddd',
      marginTop: '5px'
    },


  };



  const ContactSection: React.FC = () => {





    return (
      <>

        <div className="services-work"  >
          <div className="services-group">

            <h2 className="  text-secondary-dark" style={{
              marginBottom: "23px"
            }}>Still have questions?</h2>
            <p className="  text-secondary-dark" style={{
              marginBottom: "23px"
            }}>
              Reach us to get answers for all your questions about rental, payments
              and more.
            </p>

            <button className="btn btn-secondary text-white     mb-5 " type="button" data-bs-toggle="modal" data-bs-target="#enquiry"
              style={{
                background: "#1D3A56"
              }}>Call Us</button>


          </div>
        </div>


        <div className="services-content row align-items-center bg-secondary-dark text-white p-4 pt-0 m-0 position-relative border-1 ">

          <div className="row">
            <div className="text-center mb-4 col-12">
              <img
                src={isMobile ? "../../assets/img/home/about.png" : "../../assets/img/home/about-large.png"} // replace with actual image path
                alt="Car"
                className="about-img"

              />
            </div>
          </div>

          <div className="row justify-content-center  contact ">
            <div className="    mb-5 col-12 col-md-3 d-flex justify-content-center  justify-content=md-left">
              <img
                src={"../../assets/img/home/whitelogo.png"}
                className="logo"
                alt="logo"


              />
            </div>

            <div className="d-flex gap-3 col-12 col-md-3  d-grid d-md-none ">

              <div className="text-center" style={{ width: "32px" }}>
                <img src="../../assets/img/home/map.png" />
              </div>


              <p className="text-territory pb-4 ">  {systemSettings?.default_pickup_location}</p>

            </div>

            <div className="d-flex gap-3 col-12 col-md-3  d-grid d-md-none">

              <div className="text-center" style={{ width: "32px" }}>
                <img src="../../assets/img/home/support.svg" />
              </div>


              <p className="text-territory pb-4  ">Phone: {systemSettings?.contact_phone}</p>

            </div>


            <div className=" col-12  col-md-3   ">

              <div className="d-flex gap-3 d-none d-md-grid">

                <p className="mb-4"> Location</p>
              </div>


              <div className="d-none d-md-flex gap-3">

                <div className="text-center" style={{ width: "32px" }}>
                  <img src="../../assets/img/home/map.png" />
                </div>

                <p className="text-territory pb-4  ">{systemSettings?.default_pickup_location}</p>
              </div>

              <div className="d-flex gap-3 d-md-none" >
                <div className="text-center" style={{ width: "32px" }}>
                  <img src="../../assets/img/home/email.svg" />
                </div>


                <p className="text-territory pb-4 pb-md-2 ">Email: {systemSettings?.contact_email}</p>
              </div>


            </div>


            <div className="col-12   col-md-3  d-none d-md-grid">
              <div className="d-flex gap-3">

                <p className="mb-4 "> Contact</p>
              </div>


              <div className="d-flex gap-3">

                <div className="text-center" style={{ width: "32px" }}>
                  <img src="../../assets/img/home/support.svg" />
                </div>


                <p className="text-territory pb-4  ">Phone: {systemSettings?.contact_phone}</p>

              </div>
              <div className="d-flex gap-3">
                <div className="text-center" style={{ width: "32px" }}>
                  <img src="../../assets/img/home/email.svg" />
                </div>


                <p className="text-territory pb-4 pb-md-2  ">Email: {systemSettings?.contact_email}</p>
              </div>

            </div>


            <div className="mt-4 text-center col-12 col-md-3 py-2 py-md-0 mt-md-0 ">
              <p className="text-territory mb-4">We are exploring other locations.</p>
              <button className="  btn bg-none border border-white bw-bold text-white w-100 ptb1516   " data-bs-toggle="modal" data-bs-target="#enquiry">
                Be the first to know
              </button>
            </div>

          </div>





        </div>


        <p className="bg-secondary-dark fs-13 mb-0 py-2 pb-5 text-center text-territory  border border-bottom ">
          Copyrights © 2025 FaiRental. All Rights Reserved.
        </p>

      </>
    );
  };



  type ServiceItem = {
    icon: string;
    title: string;
    description: string;
  };


  const services: ServiceItem[] = [
    {
      icon: "assets/img/home/shield.png",
      title: "Drive hassle free",
      description: "Full Insurance, Maintenance and Roadside Included.",
    },
    {
      icon: "assets/img/home/money.png",
      title: "Pay as you earn",
      description: "Affordable options - Long time rental with micro payments.",
    },
    {
      icon: "assets/img/home/doors.png",
      title: "Reserve any car",
      description: "Choose from a wide range of cars & book exclusively.",
    },
    {
      icon: "assets/img/home/support.png",
      title: "24/7 support",
      description: "Immediate support is available anytime to assist you.",
    },
  ];


  const ServicesSection: React.FC = () => {
    return (


      <div className="services-work">
        <div className="row px-1">
          {services.map((service, index) => (
            <div
              key={index}
              className={`col-md-3 col-12     `}
              data-aos="fade-down"
            >
              <div className="services-group">

                <h2 className="mb-0 d-flex align-items-center">
                  <ImageWithBasePath
                    className="icon-img"
                    src={service.icon}
                    alt={service.title}
                  />
                  {service.title}
                </h2>
                <p className="text-justify  px-0  my-3">{service.description}</p>

              </div>
            </div>
          ))}
        </div>
      </div>


    );
  };


  const HomeSection: React.FC = () => {
    return (
      <>
        <div className="services-work" >

          <h2 className="text-center pt-0">Rent now. Pay later</h2>

          <p className="mb-0 text-center pt-md-4  px-4"  >
            Drive for Uber, Lyft, or enjoy a long-term rental. Pay as you earn, unlimited miles, zero hassle.
          </p>


          <div className={`container mx-0 mb-2 px-0 home-banner-img`}  >
            <div className="row align-items-end">


              <div className="col-12 col-12 col-md-4   pe-md-2 location" >
                <label htmlFor="calendar-12h " className="explore-text text-white "> Location </label>

                {/* <input type="location" className={`form-control mb-0 text-black ptb1516`} value={"Dallas, Texas"} readOnly /> */}
                <select
                  value={location}
                  onChange={(e) => {

                    if (e.target.value === "1") {
                      setLocation(e.target.value)
                    } else {

                      const locationModal = document.getElementById("location-modal");

                      if (locationModal) {
                        locationModal.style.display = "block";
                        locationModal.classList.add("show", "modal-open");
                      }


                      const backdrop = document.createElement("div");
                      backdrop.className = "modal-backdrop fade show";
                      document.body.appendChild(backdrop);
                      document.body.classList.add("modal-open");
                      document.body.style.overflow = "hidden";
                      document.body.style.paddingRight = "0px";


                    }
                  }}
                  className="form-select text-black ptb1516 w-100 px-2" >
                  {locationList?.map((data: any, index: number) => (
                    <option key={index} value={data?.id}>
                      {data?.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className="  col-12 col-md-3  px-md-2 from" >
                <div className="">
                  <label htmlFor="calendar-12h " className="explore-text text-white"> From </label>

                  <div className="d-flex gap-3">

                    <Calendar
                      minDate={new Date()}
                      className="ptb p-0 text-black"

                      value={startDate ?? undefined}
                      onChange={(e) => {
                        const selectedDate = e.value as Date;

                        setStartDate(selectedDate);

                        if (selectedDate && systemSettings?.booking_min_duration) {
                          const duration = parseInt(systemSettings.booking_min_duration);
                          const calculatedEndDate = new Date(
                            new Date(selectedDate).setDate(selectedDate.getDate() + duration)
                          );
                          setEndDate(calculatedEndDate);
                        } else {
                          setEndDate(undefined);
                        }
                      }}
                      onHide={() => setShowCalendar(false)}
                      visible={showCalendar}
                      dateFormat="D, M d"
                    />

                    <select
                      value={fromTime}
                      onChange={(e) => setFromTime(e.target.value)}
                      className="form-select text-black ptb1516 w-100 px-2" >
                      {timeOptions.map((time, index) => (
                        <option key={index} value={time}>
                          {time}
                        </option>
                      ))}
                    </select>

                  </div>
                </div>

              </div>

              <div className="  col-12 col-md-3  px-md-2 until" >
                <div className="">
                  <label htmlFor="calendar-12h" className="explore-text text-white mb-0"> Until </label>
                  <div className="d-flex gap-3">
                    <Calendar className="text-black ptb" value={endDate}

                      minDate={
                        startDate && systemSettings?.booking_min_duration
                          ? new Date(
                            new Date(startDate).setDate(
                              new Date(startDate).getDate() + parseInt(systemSettings.booking_min_duration)
                            )
                          )
                          : undefined
                      }
                      onChange={(e) => {
                        setEndDate(e.value);

                      }}
                      onHide={() => setShowCalendar(false)} visible={showCalendar} dateFormat="D, M d" />

                    <select
                      value={untilTime}

                      onChange={(e) => {

                        setUntilTime(e.target.value)

                      }}
                      className="form-select text-black ptb1516 py-0 w-100 px-2 "

                    >
                      {timeOptions.map((time, index) => (
                        <option key={index} value={time}>
                          {time}
                        </option>
                      ))}
                    </select>

                  </div>
                </div>

              </div>

              <div className="  col-12 col-md-2 text-center  ps-md-2   search" >
                <div className="">
                  <label htmlFor="calendar-12h" className="explore-text text-white mb-0">   </label>
                  <button onClick={() => { handleSearchSubmit(); }}
                    className="btn  w-100 ptb1516 " type="button" >Search for Cars </button>
                </div>
              </div>


              <div className="bannerimage  text-center mt-0 pb-0 pb-md-2">
                <ImageWithBasePath
                  src="assets/img/home/home-car.png"
                  className="img-fluid aos"
                  alt="bannerimage"
                />

              </div>

            </div>


          </div>




        </div>



      </>
    );
  };

  const FooterSection: React.FC = () => {
    return (
      <>
        <div className="d-block d-md-none homefooter"  >
          <div className="d-flex gap-2 homefooterspace">
            <Link to="https://bonjour.uber.com/marketplace/marketplaces/vehicles_us/earnings_share/product/aea42e6b-b85a-5dbe-8991-8ae8f99dec71/offer/cc7af0f5-89ca-58f8-abc7-751d4e4eaab7"

              target="_blank"
              className="btn  text-black w-100"

              style={{
                background: "#E4F6FC",
                padding: "10px  0px 11px 0px",

              }} >Find our cars in Uber </Link>
            <button className="btn     text-white w-100"
              onClick={() => { handleSearchSubmit(); }}
              style={{
                background: "linear-gradient(99deg, #00B6F0, #9AE6FD)",
                padding: "10px  0px 11px 0px",

              }} > Search for Cars </button>

          </div>
        </div>
      </>
    );
  };


  return (
    <>



      <Header />

      <ToastContainer autoClose={3000} />

      <div className="listing-page container-fluid h-100 px-0" >

        <section className="home-section" >
          <HomeSection />
        </section>


        <section className="services-section pt-2 mt-md-5" >
          <ServicesSection />
        </section>

        <section className="category-section bg-territory" >
          <BrowseByCategory />
        </section>

        <section className="how-section"  >
          <HowItWorks />
        </section>


        {topDealCars.length > 0 &&
          <section className="dealCars-section" >

            <TopDealCars />

          </section>}


        <section className="fairental-section">

          <FairentalSection />
        </section>

        <section className="driver-income-section">
          <DriverIncomeSection />
        </section>

      </div>

      <section className="testimonial-section">
        <Testimonial />
      </section>


      <section className="faq-section">

        <FAQSection />
      </section>



      <section className="contact-section">

        <ContactSection />
      </section>




      <FooterSection />


      <div
        className="modal new-modal fade"
        id="location-modal"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content py-0 ">
            <div className="modal-header border-bottom-0">

              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
                onClick={() => {


                  const backdrop = document.querySelector(".modal-backdrop");
                  const locationModal = document.getElementById("location-modal");

                  if (locationModal) {
                    locationModal.style.display = "none";
                    locationModal.classList.remove("show", "modal-open");
                  }
                  if (backdrop) {
                    backdrop.remove();
                  }

                  document.body.classList.remove("modal-open");
                  document.body.style.overflow = "";
                  document.body.style.paddingRight = "";



                }}
              >
                <span>×</span>
              </button>
            </div>

            <div className="modal-body ">



              <div className="row  mb-3">
                <p>
                  {`We are about to launch in Houston. `}
                  {!user?.id && (
                    <>
                      Be the first to know. Please sign up{" "}
                      <Link
                        to={`/authentication/register?location=2`}
                        onClick={() => {
                          const backdrop = document.querySelector(".modal-backdrop");
                          const locationModal = document.getElementById("location-modal");

                          if (locationModal) {
                            locationModal.style.display = "none";
                            locationModal.classList.remove("show", "modal-open");
                          }
                          if (backdrop) {
                            backdrop.remove();
                          }

                          document.body.classList.remove("modal-open");
                          document.body.style.overflow = "";
                          document.body.style.paddingRight = "";
                        }}
                      >
                        here
                      </Link>{" "}
                      and we will get back to you shortly.
                    </>
                  )}
                </p>


              </div>

              {/* <div className="row p-2">

                <div className="">
                  <button type="button" className="btn btn-primary btn-size"
                    data-bs-dismiss="modal"

                  >Close</button>

                </div>

              </div> */}
            </div>
          </div>
        </div>
      </div>


      <ContactForm register={register} errors={errors} handleSubmit={handleSubmit} onSubmit={onSubmit} contactUsLoading={contactUsLoading} />
      <ContactConfirm closeConfirmModal={closeConfirmModal} />


      {/* <Footer /> */}
    </>
  );
};

export default HomeOne;